import { TOOL_LOGO_MAP } from '../constants/tool-access.constants';

export const toolLogoUrl = (toolName: string | null | undefined): string | null => {
  if (!toolName) return null;
  return TOOL_LOGO_MAP[toolName.trim().toLowerCase()] ?? null;
};

export const toolInitial = (toolName: string | null | undefined): string =>
  (toolName ?? '').trim().charAt(0).toUpperCase() || '?';
